import { TableBody, TableHead, TableWrapper } from "./components";
import { TableRow } from "./components/TableRow/TableRow";
import style from "./CostStatistics.module.scss";

export function CostStatistics() {
    return (
        <div className={style.container}>
            <p className={style.label}>Статистика витрат</p>
            <div data-scrollable className={style.scrollBox}>
                <TableWrapper>
                    <TableHead />
                    <TableBody>
                        {(data, i) => (
                            <TableRow key={i} data={data} />
                        )}
                    </TableBody>
                </TableWrapper>
            </div>
        </div>
    )
}